import axios from "axios";

const BASE_URL = "http://3.120.246.52:9004/main/v1/api/";

export const publicRequest = axios.create({
  baseURL: BASE_URL,
});
